import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import TasksDueNotificationCard from '../TasksDueNotificationCard';
import { toHumanReadableDate } from '../../../../shared/services/dateService';

/**
 * @typedef {object} ObservationReportNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {ObservationReportNotificationProps} props
 */
const ObservationReportNotification = props => {
  const { notification } = props;
  const redirectUrl = pageUrlService.getObservationReportPageUrl(
    notification.EventId,
    notification.ObservedUser.Id
  );
  const formattedDueDate = toHumanReadableDate(notification.DueDate);

  return (
    <TasksDueNotificationCard
      label={`${notification.ObservedUser.FullName} Observation Report is due by ${formattedDueDate}`}
      dueDate={notification.DueDate}
      redirectUrl={redirectUrl}
    />
  );
};

export default ObservationReportNotification;
